import {
    CREATE_STYLE_MASTER_MAIN_FAILURE,
    CREATE_STYLE_MASTER_MAIN_REQUEST,
    CREATE_STYLE_MASTER_MAIN_SUCCESS,
    CREATE_USER_FORM_STYLE_MASTER_MAIN,
    DELETE_STYLE_MASTER_MAIN_FAILURE,
    DELETE_STYLE_MASTER_MAIN_REQUEST,
    DELETE_STYLE_MASTER_MAIN_SUCCESS,
    FETCH_STYLE_MASTER_MAIN_FAILURE,
    FETCH_STYLE_MASTER_MAIN_REQUEST,
    FETCH_STYLE_MASTER_MAIN_SUCCESS,
    FETCH_SINGLE_STYLE_MASTER_MAIN_FAILURE,
    FETCH_SINGLE_STYLE_MASTER_MAIN_REQUEST,
    FETCH_SINGLE_STYLE_MASTER_MAIN_SUCCESS,
    STYLE_MASTER_MAIN_USERFORM_RESET,
    UPDATE_STYLE_MASTER_MAIN_FAILURE,
    UPDATE_STYLE_MASTER_MAIN_REQUEST,
    UPDATE_STYLE_MASTER_MAIN_SUCCESS,
    STYLE_MASTER_MAIN_USERFORM_DROPDOWNLIST_RESET,
    FETCH_STYLE_MASTER_MAIN_BUYER_NAME_REQUEST,
    FETCH_STYLE_MASTER_MAIN_BUYER_NAME_SUCCESS,
    FETCH_STYLE_MASTER_MAIN_BUYER_NAME_FAILURE,
    SET_SINGLE_STYLE_MAIN_OBJ,
    CHECK_DEMAND_BY_STYLE_ID_REQUEST,
    CHECK_DEMAND_BY_STYLE_ID_SUCCESS,
    CHECK_DEMAND_BY_STYLE_ID_FAILURE,
    CHECK_DEMAND_BY_SALEORDER_ID_REQUEST,
    CHECK_DEMAND_BY_SALEORDER_ID_SUCCESS,
    CHECK_DEMAND_BY_SALEORDER_ID_FAILURE,
    STYLE_CREATION_BY_ID_REQUEST,
    STYLE_CREATION_BY_ID_FAILURE,
    STYLE_CREATION_BY_ID_SUCCESS,
    GET_UPDATE_DATA_SUCCESS,
    GET_UPDATE_DATA_REQUEST,
    GET_UPDATE_DATA_FAILURE,
    FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_SUCCESS,
    FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_REQUEST,
    FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_FAILURE,
    SET_TAB_FOR_STYLE_CREATION,
    FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_SUCCESS,
    FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_REQUEST,
    FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_FAILURE
} from './styleMasterMain.actionsType';

export const STYLE_MASTER_MAIN = 'styleMasterMain';

let initialState = {
    loading: false,
    styleMasterMainList: [],
    buyerName: [],
    userform: {},
    singleStyleObj: {},
    styleMasterId: '',
    checkDemandStatus: '',
    checkDemandSalesOrder: '',
    errorMessage: '',
    fldStyleNumber: '',
    activekey: 1

};

export let styleMasterMainReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STYLE_MASTER_MAIN_REQUEST:
        case CREATE_STYLE_MASTER_MAIN_REQUEST:
        case UPDATE_STYLE_MASTER_MAIN_REQUEST:
        case FETCH_SINGLE_STYLE_MASTER_MAIN_REQUEST:
        case DELETE_STYLE_MASTER_MAIN_REQUEST:
        case FETCH_STYLE_MASTER_MAIN_BUYER_NAME_REQUEST:
        case CHECK_DEMAND_BY_STYLE_ID_REQUEST:
        case STYLE_CREATION_BY_ID_REQUEST:
        case GET_UPDATE_DATA_REQUEST:
        case FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_REQUEST:
        case FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STYLE_MASTER_MAIN_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterMainList: updatePayload
            };
        case FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_SUCCESS:
            return {
                ...state,
                loading: false,
                copyTrackStyleChanges: updatePayload
            };
        case CHECK_DEMAND_BY_STYLE_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                checkDemandStatus: updatePayload
            };
        case GET_UPDATE_DATA_SUCCESS:
            return {
                ...state,
                editedDataLists: updatePayload,
            }
        case CHECK_DEMAND_BY_SALEORDER_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                checkDemandSalesOrder: updatePayload
            };
        case FETCH_STYLE_MASTER_MAIN_BUYER_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                buyerName: updatePayload
            };
        case SET_SINGLE_STYLE_MAIN_OBJ:
            return {
                ...state,
                loading: false,
                singleStyleObj: payload
            };
        case CREATE_STYLE_MASTER_MAIN_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case UPDATE_STYLE_MASTER_MAIN_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_STYLE_MASTER_MAIN_SUCCESS:
            let lettersEdit = updatePayload.fldStyleNumber.match(/[A-Za-z]+/g).join('');
            let numbersEdit = updatePayload.fldStyleNumber.match(/\d+/g).join('')
            return {
                ...state,
                loading: false,
                userform: {
                    ...updatePayload,
                    fldStyleNumber: numbersEdit,
                    fldStyleText: lettersEdit
                }
            };
        case DELETE_STYLE_MASTER_MAIN_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case STYLE_CREATION_BY_ID_SUCCESS:
            return {
                ...state,
                styleMasterMainList: updatePayload

            }
        case SET_TAB_FOR_STYLE_CREATION:
            return {
                ...state,
                activeKey: payload
            };
        case FETCH_STYLE_MASTER_MAIN_FAILURE:
        case CREATE_STYLE_MASTER_MAIN_FAILURE:
        case UPDATE_STYLE_MASTER_MAIN_FAILURE:
        case FETCH_SINGLE_STYLE_MASTER_MAIN_FAILURE:
        case DELETE_STYLE_MASTER_MAIN_FAILURE:
        case FETCH_STYLE_MASTER_MAIN_BUYER_NAME_FAILURE:
        case CHECK_DEMAND_BY_STYLE_ID_FAILURE:
        case STYLE_CREATION_BY_ID_FAILURE:
        case GET_UPDATE_DATA_FAILURE:
        case FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_FAILURE:
        case FETCH_STYLE_MASTER_COPY_STYLE_TRACK_CHANGES_FAILURE:
            return {
                ...state,
                loading: false,
                showErrorAlert: true,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_STYLE_MASTER_MAIN:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_STYLE_MASTER_MAIN_STYLE_NUMBER_SUCCESS:
            let letters = updatePayload.match(/[A-Za-z]+/g).join('');
            let numbers = updatePayload.match(/\d+/g).join('')
            return {
                ...state,
                userform: {
                    ...state.userform,
                    fldStyleNumber: numbers,
                    fldStyleText: letters
                }
            }
        case STYLE_MASTER_MAIN_USERFORM_RESET:
            return {
                ...state,
                userform: {}
            };
        case STYLE_MASTER_MAIN_USERFORM_DROPDOWNLIST_RESET:
            return {
                ...state,
                userform: { ...state.userform, BuyName: '' }
            };
        default:
            return state;
    }
};
